// extracted by mini-css-extract-plugin
export default {"color_nav":"navbar_color_nav__KuWJt","custom_toggler":"navbar_custom_toggler__ZNcEV"};